import { isAxiosError } from 'axios';

/** Prefer Nest `message` field from JSON body; fallback to Error.message. */
export function extractApiErrorMessage(error: unknown): string {
  if (isAxiosError(error)) {
    const data = error.response?.data as { message?: string | string[] } | undefined;
    const raw = data?.message;
    if (typeof raw === 'string' && raw.trim()) return raw;
    if (Array.isArray(raw) && raw.length > 0) return raw.join('; ');
    if (error.response?.status === 403) {
      return 'Forbidden — check your role (scopes) and project type.';
    }
  }
  if (error instanceof Error) return error.message;
  return 'Request failed';
}
